import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import {finalize} from 'rxjs/operators';

@Injectable()
export class ApiService {
    endpoint;
    hiveendpoint;
    headers;
    routes;
    currentUserId;
    wpendpoint;
    team;
    sites;
    progress = new Subject<boolean>();
    foundPosts = 0;
    heartbeat = new Subject();
    heartbeatTimer;
    heartbeatInterval = 60000; // 60 seconds
    loggedOut = true;
    _versionChanged = false;
    versionChange = new EventEmitter();
    version = '';
    retryError = new Subject();

    constructor(private http: HttpClient) {
        this.init();
        this.tick();
        this.heartbeat.subscribe(() => {
            let nonce = this.getProp('nonce');
            this.doAction('post', 'heartbeat', {
                nonce: nonce
            }).subscribe(
                data => {
                    this.setProp('currentUserId', data.user);
                    if( data.nonce !== nonce ) {
                        this.setNonce(data.nonce);
                    }
                    this.maybeUpdateVersion(data.version);
                    if( data.taxonomies ) {
                        this.setProp('taxonomies', data.taxonomies);
                    }
                    if( data.techniques ) {
                        this.setProp('techniques', data.techniques);
                    }
                    if( data.blacklist ) {
                        this.setProp('blacklist', data.blacklist);
                    }
                    if( data.affiliates ) {
                        this.setProp('affiliates', data.affiliates);
                    }
                }
            );
        });
    }
    resuscitate(id) {
        this.setProp('currentUserId', id);
        this.tick();
    }
    maybeUpdateVersion(version) {
        if( version !== this.version ) {
            this.versionChange.emit(true);
            this.version = version;
            this._versionChanged = true;
        }
    }
    doAction(action, location, args) {
        let url = this.getEndpoint(location);
        this.progress.next(true);
        return this[action](url, args);
    }
    getQueryArr(params, prefix) {
        let queryArr = [];
        for(var key in params) {
            let value = params[key];
            if( Array.isArray(value) ) {
                for(let i = 0; i < value.length; i++) {
                    let values = value[i];
                    let prefix = key + '[' + i + ']';
                    let innerQueryArr = this.getQueryArr(values, prefix);
                    queryArr = queryArr.concat(innerQueryArr);
                }
            } else {
                if( prefix ) {
                    key = prefix + '[' + key + ']'
                }
                queryArr.push(key + '=' + value); 
            }            
        }
        return queryArr;
    }
    buildQuery(url, params) {
        let queryArr = this.getQueryArr(params, false);
        if( queryArr.length > 0 ) {
            url += '?' + queryArr.join('&');
        }
        return url;
    }
    get(url, args) {
        url = this.buildQuery(url, args);
        return this.http.get(url, {headers: this.headers}).pipe(finalize(() => {
            this.progress.next(false);
        }));
    }
    post(url, args) {
        return this.http.post(url, args, {headers: this.headers}).pipe(finalize(() => {
            this.progress.next(false);
        }));
    }
    files(url, args) {
        let headers = JSON.parse(JSON.stringify(this.headers));
        delete headers['Content-Type'];
        return this.http.post(this.endpoint + 'image', args, {headers: headers}).pipe(finalize(() => {
            this.progress.next(false);
        }));
    }
    delete(url, args) {
        url = this.buildQuery(url, args);
        return this.http.delete(url, {headers: this.headers}).pipe(finalize(() => {
            this.progress.next(false);
        }));
    }
    slack(payload) {
        payload = 'payload=' + JSON.stringify(payload);
        let url = 'https://hooks.slack.com/services/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'; // prod
        if( window.location.hostname.indexOf('wfmulti.wpengine.com') === -1 || window.location.hostname.indexOf('swarm.hivemedia.com') === -1 ) {
            url = 'https://hooks.slack.com/services/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'; // dev, staging
        }
        this.http.post(url, payload, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Accept': '*/*'
            }
        }).subscribe(
            data => {}, // stop error messages from hitting the swarm error handler
            err => {}
        );
    }
    getEndpoint(end) {
        let endpoint = this.endpoint + end;
        if( this.routes.indexOf(end) === -1 ) {
            endpoint = this.wpendpoint + end;
        }
        return endpoint;
    }
    getProp(prop) {
        return this[prop];
    }
    setProp(prop, item) {
        this[prop] = item;
    }
    getNonce() {
        return this.headers['X-WP-Nonce'];
    }
    removeNonce() {
        delete this.headers['X-WP-Nonce'];
    }
    setNonce(nonce) {
        this.headers['X-WP-Nonce'] = nonce;
    }
    init() {
        try {
            let vars = JSON.parse(localStorage.swarmApi);
            for(var prop in vars ) {
                this[prop] = vars[prop];
            }
            if( this.currentUserId !== 0 ) {
                this.loggedOut = false;
            }
        } catch(e) {
            console.log('Init ApiService failed.', e);
        }
    }
    tick() {
        if( !this.heartbeatTimer && this.getProp('currentUserId') ) {
            this.heartbeatTimer = setTimeout(() => {
                this.heartbeatTimer = null;
                if( document.hasFocus() ) {
                    this.heartbeat.next();
                }
                this.tick();
            }, this.heartbeatInterval);
        }
    }
}